
import { supabase } from '@/integrations/supabase/client';
import { useState } from 'react';

export const useAuthStatus = () => {
  const [isCheckingAuth, setIsCheckingAuth] = useState(false);
  
  const checkAuthStatus = async () => {
    setIsCheckingAuth(true);
    try {
      const { data, error } = await supabase.auth.getUser();
      
      if (error || !data.user) {
        throw new Error('User not authenticated');
      }
      
      return data.user;
    } catch (error) {
      console.error('Auth status check error:', error);
      throw error;
    } finally {
      setIsCheckingAuth(false);
    }
  };
  
  return {
    checkAuthStatus,
    isCheckingAuth
  };
};
